import { createRouter, createWebHashHistory } from 'vue-router'
import OpenApiDebugView from '../views/OpenApiDebugView.vue'
import { DEFAULT_ENDPOINT_HASH_ID } from '../config/openEndpoints'

const routes = [
  {
    path: '/',
    redirect: () => ({ name: 'open-api-debug', params: { hashId: DEFAULT_ENDPOINT_HASH_ID } })
  },
  {
    path: '/:hashId',
    name: 'open-api-debug',
    component: OpenApiDebugView,
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
